import { Component } from 'react';

export default class BaseComponent extends Component {
    state = {
        isPos: false,
    }

    componentWillMount = () => {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.onResize);
    }

    onResize = () => {
        let state = {...this.state};
        let width = window.innerWidth;
        state.isPos = width <= 800;
        this.setState(state);
    }

    isAdmin = () => {
        return localStorage.getItem("role") === 'Administrador'
            || localStorage.getItem("role") === 'Administrador Barras'
    }
}